import { createSelector } from 'reselect';
import { fromJS, List } from 'immutable';

const receiptsSelector = state => {
    return state.receipts;
};

const receiptItemsSelector = createSelector(
    receiptsSelector,
    receipts => {
        return receipts.get('items') || List([]);
    }
);

const receiptIdSelector = (state, props) => {
    return props.match.params.id;
};

// export const receiptSelector = createSelector(receiptItemsSelector, receiptIdSelector, (items, receiptID) => {
//   return items.filter(item => item.get('id') === receiptID).first() || fromJS({})
// })

export const receiptSelector = (state, props) => {
    return state.receipts.getIn(['details', props.match.params.id, 'receipt'], fromJS({}));
};

export const usersSelector = createSelector(
    receiptItemsSelector,
    receipts => {
        let map = fromJS({});
        receipts.forEach(receipt => {
            map = map.set(receipt.get('user'), {
                payload: '' + receipt.get('user'),
                text: '' + receipt.get('user'),
            });
        });
        const list = List([{ payload: '-1', text: 'Alle Erfasser' }]).push(...map.toList());
        return list;
    }
);

export const branchesSelector = createSelector(
    receiptItemsSelector,
    receipts => {
        let map = fromJS({});
        receipts.forEach(receipt => {
            map = map.set(receipt.get('branch'), {
                payload: '' + receipt.get('branch'),
                text: '' + receipt.get('branch'),
            });
        });
        const list = List([{ payload: '-1', text: 'Alle Filialen' }]).push(...map.toList());
        return list;
    }
);
